import { TAction, TDispatch } from "../../../types";
import {
  HomePageAction,
  HomePageActionType,
  HomePageModel,
} from "./types";
import { fetchAPI } from "../../../../config/axios";
import { AxiosResponse } from "axios";

export const HomePageDefault: HomePageModel = {
  main: {
    data: [],
    total: 0,
  },
  detail: {
    data: {} as any,
  },
};

export const HomePageReducer = (
  state: HomePageModel = HomePageDefault,
  action: HomePageAction
): HomePageModel => {
  switch (action.type) {
    case HomePageActionType.GetAllHomePage:
      return { ...state, main: action.data };
    case HomePageActionType.GetDetailHomePage:
      return { ...state, detail: action.data };
    default:
      return { ...state };
  }
};

export const HomePageCommand = {
  GetAllHomePage: (params?: unknown): TAction<HomePageAction, void> => {
    return (dispatch: TDispatch<HomePageAction>) => {
      return fetchAPI()
        .get("/home-page", { params: params })
        .then((response) => {
          dispatch({
            data: {
              data: response.data.data.data,
              total: response.data.data.total,
            },
            type: HomePageActionType.GetAllHomePage,
          });
        });
    };
  },
  GetAllHomePageData: (params?: unknown): TAction<HomePageAction, Promise<HomePageModel[]>> => {
    return (dispatch: TDispatch<HomePageAction>) => {
      return fetchAPI()
        .get("/home-page", { params: params })
        .then((response) => {
          dispatch({
            data: {
              data: response.data.data.data,
              total: response.data.data.total,
            },
            type: HomePageActionType.GetAllHomePage,
          });
          return response.data.data.data; // Return the data
        });
    };
  },
  GetDetailHomePage: (
    params?: unknown
  ): TAction<HomePageAction, void> => {
    return async (dispatch: TDispatch<HomePageAction>) => {
      try {
        const response = await fetchAPI().get("/home-page", {
          params: params,
        });
        dispatch({
          data: {
            data: response.data.data,
          },
          type: HomePageActionType.GetDetailHomePage,
        });
      } catch (error) {
        throw error;
      }
    };
  },
  CreateHomePage: (
    body?: any
  ): TAction<HomePageAction, AxiosResponse<any, any>> => {
    return async (dispatch: TDispatch<HomePageAction>) => {
      try {
        const response = await fetchAPI().post("/home-page", body);
        return response;
      } catch (error) {
        throw error;
      }
    };
  },
  UpdateHomePage: (
    body: any
  ): TAction<HomePageAction, AxiosResponse<any, any>> => {
    return async (dispatch: TDispatch<HomePageAction>) => {
      try {
        const response = await fetchAPI().post("/update-home-page", body);
        return response;
      } catch (error) {
        throw error;
      }
    };
  },
  DeleteHomePage: (
    body: any
  ): TAction<HomePageAction, AxiosResponse<any, any>> => {
    return async (dispatch: TDispatch<HomePageAction>) => {
      try {
        const response = await fetchAPI().delete("/delete-home-page", { data: body });
        return response;
      } catch (error) {
        throw error;
      }
    };
  },
};
